import { ReactElement, ReactNode, useState } from "react"
import { v4 as uuid4 } from "uuid"

import CreateEVACDeviceProvider from "./baseProviders/createEVACDeviceProvider"
import { useGetUserData } from "../../../../../hooks/useGetUserData"
import { getEmptyEVACDeviceFormData } from "../../../../../utils/registerDevice/registerDeviceUtils"
import { EVACDeviceFormData } from "../../types/providerTypes"

interface IPublishEVACDeviceProviderProps {
    children: ReactNode
}

/** Provide for the publish EVDC provider form */
const PublishEVACDeviceProvider = ({
    children,
}: IPublishEVACDeviceProviderProps): ReactElement => {
    const [formData, setFormData] = useState<EVACDeviceFormData>(
        getEmptyEVACDeviceFormData()
    )

    const { isEnaSysAdmin } = useGetUserData()

    const [attachmentUUID] = useState<string>(uuid4())

    return (
        <CreateEVACDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={false}
            canEditManufacturer={isEnaSysAdmin}
            attachmentUUID={attachmentUUID}
        >
            {children}
        </CreateEVACDeviceProvider>
    )
}

export default PublishEVACDeviceProvider
